// src/pages/BeerPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/layout/Header';
import beerBackground from '../assets/images/beer-glass-background.jpg';
import '../styles/beer.css';
import SEOHead from '../components/SEO/SEOHead';

const BeerPage = () => {
  const navigate = useNavigate();

  return (
    <div className="beer-page" style={{ backgroundImage: `url(${beerBackground})` }}>
    <SEOHead
      title="Bière"
      description="Découvrez notre sélection de bières locales et internationales livrées à Douala."
      canonical="https://bccv.online/beer"
    />
      <Header 
        title="Bière à Pression" 
        showBackButton={true} 
        onBackClick={() => navigate('/prototype-categories')}
      />
      
      <div className="beer-content">
        <div className="beer-content-overlay">
          <div className="beer-icon animate-float">
            <svg viewBox="0 0 24 24" className="w-full h-full" fill="currentColor">
              <path d="M4,2H19L17,22H6L4,2M6.2,4L7.8,20H8.8L7.43,6.34C8.5,6 9.89,5.89 11,7C12.56,8.56 15.33,7.69 16.5,7.23L16.8,4H6.2Z" />
            </svg>
          </div>
          
          <h2 className="beer-title">Bientôt disponible !</h2>
          
          <p className="beer-description">
            Notre sélection de bières à pression sera disponible très prochainement. 
            Nous préparons la meilleure expérience pour vous.
          </p>
          
          <button 
            onClick={() => navigate('/prototype-categories')}
            className="beer-button"
          >
            <svg className="beer-button-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            Retour aux options
          </button>
        </div>
      </div>
    </div>
  );
};

export default BeerPage;